var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 232.97 32.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:#6511f5;}.cls-1{stroke:#6511f5;stroke-width:2px;}.cls-1,.cls-3,.cls-4,.cls-5{stroke-miterlimit:10;}.cls-2{fill:#231f20;}.cls-3,.cls-4,.cls-5{stroke:#231f20;}.cls-4{fill:#80c68b;}.cls-5{fill:#12ce60;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.26,37.1a2.37,2.37,0,0,1-1.7-.59A2.31,2.31,0,0,1,39,34.79V9.55a2.4,2.4,0,0,1,.61-1.75,2.4,2.4,0,0,1,1.75-.61H56.26a1.83,1.83,0,0,1,1.36.45,1.7,1.7,0,0,1,.44,1.28,1.85,1.85,0,0,1-.44,1.34,1.79,1.79,0,0,1-1.36.46H43.32v9.45h12.1a1.9,1.9,0,0,1,1.32.44,1.66,1.66,0,0,1,.48,1.28,1.79,1.79,0,0,1-.48,1.35,1.81,1.81,0,0,1-1.32.46H43.32V34.79C43.32,36.33,42.64,37.1,41.26,37.1Z",
    transform: "translate(0 -5.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.41,37.1a2.16,2.16,0,0,1-1.62-.59,2.26,2.26,0,0,1-.57-1.64V9.13a2.24,2.24,0,0,1,.57-1.66,2.19,2.19,0,0,1,1.62-.57A2.15,2.15,0,0,1,66,7.47a2.24,2.24,0,0,1,.57,1.66V34.87A2.29,2.29,0,0,1,66,36.51,2.12,2.12,0,0,1,64.41,37.1Z",
    transform: "translate(0 -5.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.54,37.1A2,2,0,0,1,74,36.55,2.1,2.1,0,0,1,73.48,35V9.08A2.29,2.29,0,0,1,74,7.47a1.82,1.82,0,0,1,1.41-.57,2,2,0,0,1,1.15.27,4.79,4.79,0,0,1,1,1L94.81,31h-1V9a2.07,2.07,0,0,1,.53-1.51,2,2,0,0,1,1.49-.55,1.93,1.93,0,0,1,1.51.55A2.11,2.11,0,0,1,97.8,9V35a2.19,2.19,0,0,1-.49,1.51A1.61,1.61,0,0,1,96,37.1a2.32,2.32,0,0,1-1.24-.3,4.11,4.11,0,0,1-1-1L76.54,13h1V35a2.22,2.22,0,0,1-.5,1.55A1.89,1.89,0,0,1,75.54,37.1Z",
    transform: "translate(0 -5.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M106.53,36.8a1.42,1.42,0,0,1-1-.37,1.51,1.51,0,0,1-.38-1.1V8.66a1.49,1.49,0,0,1,.38-1.09,1.42,1.42,0,0,1,1-.38h9.87a13.11,13.11,0,0,1,5.17.91,7,7,0,0,1,3.23,2.62A7.52,7.52,0,0,1,125.94,15a6.68,6.68,0,0,1-1.66,4.62A8,8,0,0,1,119.8,22v-.59a7.83,7.83,0,0,1,5,2.25,7,7,0,0,1,1.83,5.06,7.31,7.31,0,0,1-2.52,6q-2.52,2.05-7.14,2Zm1.09-16.08h8.49a8.53,8.53,0,0,0,5.37-1.45,5,5,0,0,0,1.85-4.22,5,5,0,0,0-1.85-4.22,8.53,8.53,0,0,0-5.37-1.45h-8.49Zm0,13.9h9.12a8.62,8.62,0,0,0,5.46-1.45,5.29,5.29,0,0,0,1.8-4.39,5.34,5.34,0,0,0-1.8-4.45,8.75,8.75,0,0,0-5.46-1.43h-9.12Z",
    transform: "translate(0 -5.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M134.71,36.8a1.42,1.42,0,0,1-1.05-.37,1.51,1.51,0,0,1-.38-1.1V8.66a1.49,1.49,0,0,1,.38-1.09,1.42,1.42,0,0,1,1.05-.38h15.88a1.17,1.17,0,0,1,.88.3,1.07,1.07,0,0,1,.3.8,1.11,1.11,0,0,1-.3.86,1.25,1.25,0,0,1-.88.27H135.8V20.68h13.95a1.27,1.27,0,0,1,.88.27,1.05,1.05,0,0,1,.29.82,1.13,1.13,0,0,1-.29.84,1.23,1.23,0,0,1-.88.29H135.8V34.58h14.79a1.25,1.25,0,0,1,.88.27,1.06,1.06,0,0,1,.3.82,1.14,1.14,0,0,1-.3.84,1.17,1.17,0,0,1-.88.29Z",
    transform: "translate(0 -5.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M158.74,37.06a1.21,1.21,0,0,1-.93-.36,1.41,1.41,0,0,1-.33-1V8.54a1.34,1.34,0,0,1,.35-1,1.36,1.36,0,0,1,.95-.34h9.87q4.69,0,7.22,2.19a7.77,7.77,0,0,1,2.52,6.21,8.54,8.54,0,0,1-1.13,4.48,7.14,7.14,0,0,1-3.34,2.83,13,13,0,0,1-5.27,1l.46-.55h.59a4.74,4.74,0,0,1,2.79.84,7.26,7.26,0,0,1,2.16,2.73l4.46,8.28a1.61,1.61,0,0,1,.27.9,1,1,0,0,1-.31.71,1.05,1.05,0,0,1-.76.28,1.48,1.48,0,0,1-.9-.26,1.87,1.87,0,0,1-.61-.71l-4.71-8.78a6,6,0,0,0-2.43-2.66A8.3,8.3,0,0,0,166,24h-6V35.71a1.45,1.45,0,0,1-.32,1A1.24,1.24,0,0,1,158.74,37.06ZM160,21.81h8.27q3.74,0,5.61-1.57a5.76,5.76,0,0,0,1.87-4.65A5.68,5.68,0,0,0,173.92,11a8.55,8.55,0,0,0-5.61-1.58H160Z",
    transform: "translate(0 -5.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M186.5,37.06a1.19,1.19,0,0,1-.92-.36,1.37,1.37,0,0,1-.34-1V8.54a1.21,1.21,0,0,1,1.3-1.35h9.87c3.14,0,5.54.73,7.22,2.19a7.75,7.75,0,0,1,2.53,6.21A8.45,8.45,0,0,1,205,20.07a7.14,7.14,0,0,1-3.34,2.83,13,13,0,0,1-5.27,1l.46-.55h.59a4.72,4.72,0,0,1,2.79.84,7.37,7.37,0,0,1,2.17,2.73l4.45,8.28a1.54,1.54,0,0,1,.27.9,1,1,0,0,1-.31.71,1.05,1.05,0,0,1-.76.28,1.52,1.52,0,0,1-.9-.26,2,2,0,0,1-.61-.71l-4.7-8.78a6,6,0,0,0-2.44-2.66,8.28,8.28,0,0,0-3.61-.66h-6V35.71a1.45,1.45,0,0,1-.31,1A1.25,1.25,0,0,1,186.5,37.06Zm1.3-15.25h8.28q3.73,0,5.6-1.57a5.73,5.73,0,0,0,1.87-4.65A5.65,5.65,0,0,0,201.68,11q-1.86-1.58-5.6-1.58H187.8Z",
    transform: "translate(0 -5.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M221.19,37.06a1.28,1.28,0,0,1-1-.36,1.47,1.47,0,0,1-.33-1V21.43l.63,2L209.77,8.79a1.42,1.42,0,0,1-.32-.9.93.93,0,0,1,.34-.7,1.25,1.25,0,0,1,.77-.25,1.77,1.77,0,0,1,.82.19,1.83,1.83,0,0,1,.65.65l9.58,13.11h-.76l9.62-13.11a2.64,2.64,0,0,1,.65-.65,1.55,1.55,0,0,1,.78-.19,1.18,1.18,0,0,1,.76.25.94.94,0,0,1,.31.7,1.43,1.43,0,0,1-.35.94L221.9,23.45l.59-2V35.67C222.49,36.59,222.06,37.06,221.19,37.06Z",
    transform: "translate(0 -5.7)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 16.18,
    cy: 16.94,
    rx: 3.55,
    ry: 3.61
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 20.3,
    cy: 13.93,
    rx: 3.55,
    ry: 3.61
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 15.46,
    cy: 10.03,
    rx: 3.55,
    ry: 3.61
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 20.79,
    cy: 21.8,
    rx: 3.55,
    ry: 3.61
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 15.46,
    cy: 23.57,
    rx: 3.55,
    ry: 3.61
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 10.26,
    cy: 19.17,
    rx: 3.55,
    ry: 3.61
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 11.63,
    cy: 12.72,
    rx: 3.55,
    ry: 3.61
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 8.36,
    cy: 9.72,
    rx: 3.55,
    ry: 3.61
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 5.24,
    cy: 15.14,
    rx: 3.55,
    ry: 3.61
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 4.53,
    cy: 21.44,
    rx: 3.55,
    ry: 3.61
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 9.84,
    cy: 26.39,
    rx: 3.55,
    ry: 3.61
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 4.05,
    cy: 28.32,
    rx: 3.55,
    ry: 3.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M21,13.32a7.73,7.73,0,0,0,5.6-1.82A8,8,0,0,0,28.9,6.2a8.59,8.59,0,0,1-2.4,5.15A8.55,8.55,0,0,1,21,13.32Z",
    transform: "translate(0 -5.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M30.72,21.9c.25-.4,2-3.4.76-6.45-.86-2.1-3.09-4.07-4.39-3.54s-1.57,3.71-.7,5.95A7.46,7.46,0,0,0,30.72,21.9Z",
    transform: "translate(0 -5.7)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0d1b9a80e750840bff66575ba727e55a.svg";
export { ForwardRef as ReactComponent };